/* INAYAH — smart review badge treatment
 * - If a product has 0 Judge.me reviews, hide the empty "No reviews" badge on the PDP top area
 *   (we do NOT want to signal emptiness right next to the title/price).
 * - If a product has 1+ Judge.me reviews, style the badge larger, make it clickable,
 *   and scroll to the full Judge.me widget on click.
 * - Also: if the Shop App reviews section at the bottom has at least one review but Judge.me has zero,
 *   hide the Judge.me "Be the first to write a review" CTA to prevent contradicting the Shop App review.
 */
(function () {
  'use strict';

  function processBadges() {
    var badges = document.querySelectorAll('.jdgm-prev-badge');
    badges.forEach(function (badge) {
      var count = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
      var rating = parseFloat(badge.getAttribute('data-average-rating') || '0');

      // Only treat PDP top-area badges (inside .prod__title block), not footer/collection-grid ones
      var inPdpHeader = !!badge.closest('.prod__title');
      if (!inPdpHeader) return;

      if (count < 1) {
        // Hide the empty badge entirely
        badge.style.display = 'none';
        badge.setAttribute('data-inayah-hidden', 'empty');
      } else {
        // Real reviews exist — make clickable + style
        badge.style.cursor = 'pointer';
        badge.style.display = 'inline-flex';
        badge.style.alignItems = 'center';
        badge.style.marginTop = '6px';
        badge.setAttribute('data-inayah-enhanced', '1');
        if (!badge.getAttribute('data-inayah-bound')) {
          badge.setAttribute('data-inayah-bound', '1');
          badge.addEventListener('click', function (e) {
            var target = document.querySelector('.jdgm-rev-widg, #judgeme_product_reviews, .jdgm-widget');
            if (target) {
              e.preventDefault();
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
        }
      }
    });

    // Hide Judge.me "Be the first to write a review" container if Shop App has at least one review
    var emptyWriteCta = document.querySelector('.jdgm-rev-widg[data-average-rating="0.00"] .jdgm-no-reviews-panel, .jdgm-rev-widg--empty');
    var shopReviewExists = !!document.querySelector('shopify-reviews-widget, .shopify-reviews, [data-shopify-reviews]');
    if (emptyWriteCta && shopReviewExists) {
      emptyWriteCta.style.display = 'none';
    }
  }

  function init() {
    processBadges();
    // Judge.me injects badges async — re-run a few times
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      processBadges();
      if (tries >= 10) clearInterval(iv);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
